import Typography from '@components/v2/ui/Typography/Typography';
import { formatCappedCount } from '../../../../../../../../../../utils/formatters';

interface SidebarNavItemCountProps {
  value: number;
  max?: number;
  isZeroVisible?: boolean;
}

const DEFAULT_MAX_COUNT = 999;

const SidebarNavItemCount = ({
  value,
  max = DEFAULT_MAX_COUNT,
  isZeroVisible = false,
}: SidebarNavItemCountProps) => {
  if (value <= 0 && !isZeroVisible) {
    return null;
  }

  return (
    <Typography variant="body2" component="span" color="text.tertiary">
      {formatCappedCount({ count: value, max })}
    </Typography>
  );
};

export default SidebarNavItemCount;
